<script setup>
import { reactive, ref } from "vue";
import { queryMonitorTable } from "@/api/monitor";

// 传递事件
const emits = defineEmits(["afterSelect"]);

// 弹窗控制
const visible = ref(false);

// 表格列配置
const columns = ref([
  {
    label: "监听器名称",
    prop: "name",
  },
  {
    label: "类路径",
    prop: "classPath",
  },
  {
    label: "创建时间",
    prop: "createTime",
  },
  {
    label: "创建人",
    prop: "createByName",
  },
  {
    label: "更新时间",
    prop: "updateTime",
  },
  {
    label: "备注",
    prop: "remark",
  },
]);

// 表格loading
const loading = ref(false);

// 表格数据
const tableData = ref([]);

// 分页数据
const pages = reactive({
  page: 1,
  limit: 10,
  total: 0,
});

// 弹窗打开
const handleDialogOpen = () => {
  visible.value = true;
  getTableData();
};

// 获取数据
const getTableData = () => {
  loading.value = true;
  queryMonitorTable({
    page: pages.page,
    limit: pages.limit,
    enableStatus: "1",
  })
    .then((res) => {
      tableData.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      loading.value = false;
    });
};

// 点击数据
const handleCurrentChange = (val) => {
  if (!val) return;
  emits("afterSelect", val);
  visible.value = false;
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog v-model="visible" width="900px" title="监听器选择">
    <el-button
      type="primary"
      icon="Refresh"
      @click="getTableData()"
      style="margin-bottom: 10px"
      >刷新数据</el-button
    >
    <el-table
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      :data="tableData"
      v-loading="loading"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <template v-for="item in columns" :key="item.prop">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span>{{ row[item.prop] || "-" }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="pages.total > 0"
      :total="pages.total"
      v-model:current-page="pages.page"
      @update:current-page="getTableData"
      layout="->, prev, pager, next"
    />
  </el-dialog>
</template>

<style scoped></style>
